import { useMemo } from 'react';
import { useSupervisorInsightContext } from '../Notes/SupervisorInsightContextProvider';

export const useGetSearchLabels = (): {
  labelId: any;
  idValues: any;
}[] => {
  const { searchCriteriaInsights } = useSupervisorInsightContext();

  const labelValues = useMemo(() => {
    return Object.values(searchCriteriaInsights.criterions)
      .filter((x) => x.length > 0)
      .map((i: any) => {
        const idValues = i.map((s: any) => {
          return s.id;
        });

        return {
          labelId: i[0].labelId,
          idValues: idValues
        };
      });
  }, [searchCriteriaInsights]);
  return labelValues;
};
